export enum PreferenceFamily {
  ABS = 'ABS',
  CORPORATE = 'CORPORATE',
  EM = 'EM',
  NONE = 'NONE',
}
